// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPayrollGroupPatchRequestDto
 */
export interface IPayrollGroupPatchRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IPayrollGroupPatchRequestDto
     */
    name?: string;
}

/**
 * Check if a given object implements the IPayrollGroupPatchRequestDto interface.
 */
export function instanceOfIPayrollGroupPatchRequestDto(value: object): value is IPayrollGroupPatchRequestDto {
    return true;
}

export function IPayrollGroupPatchRequestDtoFromJSON(json: any): IPayrollGroupPatchRequestDto {
    return IPayrollGroupPatchRequestDtoFromJSONTyped(json, false);
}

export function IPayrollGroupPatchRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPayrollGroupPatchRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function IPayrollGroupPatchRequestDtoToJSON(json: any): IPayrollGroupPatchRequestDto {
    return IPayrollGroupPatchRequestDtoToJSONTyped(json, false);
}

export function IPayrollGroupPatchRequestDtoToJSONTyped(value?: IPayrollGroupPatchRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

